import QwDateEditorials from '@qwentes/qw-date-editorials';

export default class CommunicationToolFilterController {
  $onInit() {
    this.activeFilters = {};
    this.EDITORIALS_DATE_TYPE = {
      START: 'editorialsStartDate',
      END: 'editorialsEndDate',
    };
  }

  $onChanges(changes) {
    if (changes.communicationToolFilterPreselected && changes.communicationToolFilterPreselected.currentValue) {
      this.activeFilters = changes.communicationToolFilterPreselected.currentValue.active;
      this.filtersFormatted = this._generateFilterFormatted();
    }
  }

  onChangeFilters() {
    this.filtersFormatted = this._generateFilterFormatted();
    if (this.onChangeCommunicationToolFilter) {
      const _onChangeCommunicationToolFilter = this.onChangeCommunicationToolFilter();
      _onChangeCommunicationToolFilter && _onChangeCommunicationToolFilter(this.activeFilters, this.filtersFormatted);
    }
  }

  _generateFilterFormatted() {
    return Object.keys(this.activeFilters).reduce((acc, filterKey) => {
      const value = (filterKey === this.EDITORIALS_DATE_TYPE.START || filterKey === this.EDITORIALS_DATE_TYPE.END)
        ? this._generateDateFilterFormatted(this.activeFilters[filterKey], filterKey)
        : this.activeFilters[filterKey].value;
      return {...acc, [filterKey]: value};
    }, {});
  }

  _generateDateFilterFormatted(date, type) {
    if (!date.value) {
      return;
    }
    const firstAndLastDay = QwDateEditorials.getFirstAndLastDay(date.value);
    const dateToFormat = type === this.EDITORIALS_DATE_TYPE.START ? firstAndLastDay.first : firstAndLastDay.last;
    return QwDateEditorials.formatRaw(dateToFormat);
  }
}



// WEBPACK FOOTER //
// ./src/app/communication-tool/communication-tool-filter/communication-tool-filter.controller.js